import styled from 'styled-components';

export const ContactmeContainer = styled.div`
  background: white;
  padding: 4rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContactmeH1 = styled.h1`
  font-size: 2.2rem;
  text-align: center;
  color: black;
  margin-bottom: 3rem;
`;

export const AboutUsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 3rem;
  width: 100%;
  max-width: 1000px;
`;

export const TextContainer = styled.div`
  font-size: 1rem;
  color: #111;
  line-height: 1.8;
`;

export const StyledContactForm = styled.div`
  form {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0,0,0,0.06);
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;

    label {
      font-weight: 500;
      color: #555;
      font-size: 0.9rem;
      margin-bottom: -4px;
    }

    input, textarea {
      font-size: 1rem;
      padding: 12px 14px;
      border: 1px solid #ccc;
      border-radius: 6px;
      transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

      &:focus {
        border: 1px solid #01bf71;
        box-shadow: 0 0 0 2px rgba(1, 191, 113, 0.2);
        outline: none;
      }
    }

    textarea {
      resize: vertical;
      min-height: 140px;
    }

    input[type="submit"] {
      border-radius: 50px;
      padding: 14px 30px;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      background: #ff0080;
      color: #fff;
      border: none;
      transition: all 0.3s ease-in-out;

      &:hover {
        background: #01bf71;
        color: #010606;
      }
    }
  }
`;

export const FeedbackMessage = styled.p`
  margin-top: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  color: ${({ type }) => (type === 'success' ? '#01bf71' : '#d9534f')};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
